import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Instant Download', 'No Subscription', 'Lifetime Access', '7-Day Money-Back Guarantee'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-110" data-mp="9lbfcytwl7cj">
      <div className="mx-auto max-w-4xl text-center" data-id="element-111" data-mp="4m8l89fgoljc">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[1.9rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl sm:leading-[1.02] md:text-[3.75rem]" data-id="element-112" data-mp="4jm53lei8xpi">
          Solve an Entire Year of Accounting Lessons in Just{' '}
          <span className="italic text-brand" data-id="element-113" data-mp="nbyj55eitnfh">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-114" data-mp="3d2bn1yjw7fzr">
          Join over 1,200 teachers who have stopped improvising. Walk into your classroom with
          everything ready to explain, record, and inspire.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-115" data-mp="3e8wl4tc6p6nh">
          <img src="https://cdn.magicpatterns.com/uploads/tfxPupY7b2AcJDMP4LSUuV/20447679-dc3f-44c1-b8b9-3af5aab07a7b.webp" alt="The ACCOUNTING READY™ System: the complete 6-volume series from Year 1 to Year 6 with visual accounting charts, real-world business cases, ready-to-use assessments and the 5 strategic bonuses included" className="mx-auto w-[68%] max-w-sm sm:w-[64%]" data-id="element-116" data-mp="35aklk1tcayiw" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mt-2 sm:mt-8" data-id="element-117" data-mp="s2bckbltt7bh">
          <CtaButton href="#offer" data-id="element-118" data-mp="ichxv1qe0c30" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-119" data-mp="dd592bfyguxs">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-120" data-mp="1ayjgnc33rc57" data-mpi={index}>
                <span data-id="element-121" data-mp="162capjapi0n9">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-122" data-mp="111esj6pp56lr">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}